<div style="height:100%">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  <!-- <router-outlet *ngIf="!isIframe"> -->
  <rebar-header [UserData]="Userdata"></rebar-header>

  @if (showJobProfileMatching) {
    <div>
      <app-job-profile-matching [jobProfilePage]="'survey'"></app-job-profile-matching>
    </div>
  }
  @if (show_aq_JobProfileMatching) {
    <div>
      <app-job-profile-matching [jobProfilePage]="'aq'"></app-job-profile-matching>
    </div>
  }
  @if (showlandingJobProfile) {
    <div>
      <app-job-profile-landing></app-job-profile-landing>
    </div>
  }
  @if (showTextAnalysis) {
    <div>
      <app-text-analysis></app-text-analysis>
    </div>
  }
  @if (showTextSummarizer) {
    <div>
      <app-text-summarizer></app-text-summarizer>
    </div>
  }

  <div class="Robot-image" style="font-size: 12px;">
    <div [style.marginRight]="FilterWidthMarginPosition.y">
      <!-- <rebar-home></rebar-home> -->
      @if (showHome) {
        <div>
          @if (!isIframe) {
            <router-outlet></router-outlet>
          }
        </div>
      }
    </div>


    <div id="mySidebar" class="sidebar" [style.width]="FilterWidthMarginPosition.x">

      <div id="dvChartAddFilter" class="row" style="margin:0;">
        <div class="col-sm-8">
          <select class="custom-select" [(ngModel)]="SelFilter" (change)="GetFilterIcon()"
            style="width: 100% !important;">
            <option value="0">Add Filter</option>
            @for (FlText of FilterList; track FlText) {
              <option value={{FlText.column_name}}^{{FlText.final}}>
                {{FlText.final}}
              </option>
            }
          </select>

        </div>
        <div class="col-sm-2">
          <a href="javascript:void(0)" (click)="ApplyFilters()" style="color: white;
             padding: 0; margin-left: -20px;">
            <span class="material-icons" style="cursor:pointer;">done all</span>
          </a>
        </div>
        <div class="col-sm-2"><a href="javascript:void(0)" class="closebtn" (click)="ShowFilter()" style="color:white;">
          <span class="material-icons">close</span>
        </a></div>
        <alert id="alert-1"></alert>
      </div>
      <br />
      <div id="dvloaderForFilter" class="loader" [style.display]="DisplayDvloaderForFilter"></div>
      <div id="dvSideFilter" style="text-align: left;">
        @if (UserData) {
          <ul class="list-group list-group-flush">
            @for (SL of SentimentList; track SL) {
              <li>
                {{SL.SelDropdown}}
                <div>
                  <div style="float: left;width:90%;">
                    <ng-multiselect-dropdown style="background-color: gainsboro;" [placeholder]="'Select'"
                      [settings]="SentimentSettings" [data]="SL.SelectedList" [(ngModel)]="SL.selectedItems"
                      [disabled]="Sentimentdisabled" (onSelect)="onItemSelect($event,SL.SelDropdown)"
                      (onDeSelect)="onItemSelect($event,SL.SelDropdown)"
                      (onSelectAll)="onSelectAll($event,SL.SelDropdown,'selectAll')"
                      (onDeSelectAll)="onSelectAll($event,SL.SelDropdown,'DeselectAll')">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </li>
            }
          </ul>
        }
        <ul class="list-group list-group-flush">
          @for (ddl of dropdownList; track ddl) {
            <li>
              {{ddl.DropdownText}}
              <div>
                <div style="float: left;width:85%;">
                  <ng-multiselect-dropdown style="background-color: gainsboro;" [placeholder]="'Select'"
                    [settings]="dropdownSettings" [data]="ddl.SelectedList" [(ngModel)]="ddl.selectedItems"
                    (onSelect)="onItemSelect($event,ddl.SelDropdown)" (onDeSelect)="onItemSelect($event,ddl.SelDropdown)"
                    (onSelectAll)="onSelectAll($event,ddl.SelDropdown,'selectAll')"
                    (onDeSelectAll)="onSelectAll($event,ddl.SelDropdown,'DeselectAll')">
                  </ng-multiselect-dropdown>
                </div>
                <div style="float: right;" >
                  <span class="material-icons" style="cursor: pointer;" (click)="DeleteFilter(ddl.SelDropdown)">close</span>
                </div>
              </div>
            </li>
          }
        </ul>
      </div>

    </div>

  </div>



  <div [style.display]="showChatBot">
    <div class="messaging" [ngStyle]="ChatBotStyles">
      <div class="headind_srch">
        <div class="recent_heading">
          <h4>Interactive Assistant</h4>

        </div>
        <div style="float: right;">

          <span class="material-icons" style="cursor:pointer;color: white;margin-right: -13%;" (click)="ShowDiv('TextAnalysis')">
            arrow_back_ios
          </span>

          <span class="material-icons" style="cursor:pointer;color: white;" (click)="ShowDiv('Home')">home</span>
          <span class="material-icons" style="cursor:pointer;color: white;"
          (click)="MinMaxDiv()">home_max</span>
        </div>
      </div>

      <div class="mesgs" #scrollMe [style.display]="DisplayMesgs">

        <div class="msg_history" #myDiv>

        </div>

        <div [style.display]="LoaderForChatBot"
          style="text-align:center; float:left;position:absolute;bottom:56px;   color: #0e0e0e;">
          typing <span class="dot1"></span>
          <span class="dot1"></span>
          <span class="dot1"></span>
        </div>
      </div>

      <div class="type_msg" style="height:60px;" id="dvtxtMsg" [style.display]="DisplayTypeMsg">
        <div class="input_msg_write">
          <input type="text" class="write_msg" [(ngModel)]="SeltextVal" placeholder="Type a message" autocomplete="off"
            (keydown.enter)="PopulateChat($event.target)" />

        </div>
      </div>

    </div>
  </div>


  <div class="modal" id="myModal" role="dialog"
    [ngStyle]="{'display': mdlSampleIsOpen ? 'block' : 'none', 'opacity': 1,'background-color': '#c1babaa6'}">
    <div class="modal-dialog" style="margin: 10.75rem auto;">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Please select market unit location</h4>
          <button type="button" class="close" data-dismiss="modal" (click)=openModal(false)>&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <div class="row form-group" style="margin-left:2%;">

            <label class="col-sm-5  col-form-label"><b>Market unit location :</b></label>
            <div class="col-sm-7">
              <ul class="list-group list-group-flush">
                @for (ddl of dropdownList; track ddl) {
                  <li>
                    @if (ddl.SelDropdown == 'Market unit location') {
                      <div>
                        <div style="float: left;width:90%;">
                          <ng-multiselect-dropdown style="background-color: gainsboro;" [placeholder]="'Select'"
                            [data]="ddl.SelectedList" [(ngModel)]="ddl.selectedItems" [settings]="dropdownSettings"
                            (onSelect)="onItemSelect($event,ddl.SelDropdown)"
                            (onDeSelect)="onItemSelect($event,ddl.SelDropdown)"
                            (onSelectAll)="onSelectAll($event,ddl.SelDropdown,'selectAll')"
                            (onDeSelectAll)="onSelectAll($event,ddl.SelDropdown,'DeselectAll')">
                          </ng-multiselect-dropdown>
                        </div>
                      </div>
                    }
                  </li>
                }
              </ul>

            </div>

          </div>
          <div class="row" style="margin-left:2%;">
            <div class="col-sm-8"></div>
            <div class="col-sm-4">
              <button class="btn btn-primary" (click)="SaveMarketUnitLocation($event)">Submit</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>


  <div [style.display] = "ShowLoader">
    <div class="background-image"></div>
    <div id="loader">
    </div>
    <div class="loading">Loading results</div>
  </div>


<!-- </router-outlet> -->
</div>
